import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'
import merge from 'lodash/merge'

merge(Chart.defaults, {
  global: {
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end'
      }
    }
  },

  bar: {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  },

  horizontalBar: {
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  },

  line: {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  },

  pie: {
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'start'
      }
    }
  },

  doughnut: {
    plugins: {
      datalabels: {
        anchor: 'center',
        align: 'center'
      }
    }
  },

  scatter: {
    plugins: {
      datalabels: {
        display: false
      }
    }
  }
})
